import { func } from 'prop-types';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '~/components/button';
const CommentNotAvailableModal = ({ hideModal }) => {
    CommentNotAvailableModal.propTypes = {
        hideModal: func,
    };
    const location = useLocation();
    const navigate = useNavigate();
    const invalidCommentReload = () => {
        const splitPathname = location.pathname.split('/');
        splitPathname.pop();
        navigate(splitPathname.join('/'), { replace: true });
        hideModal();
    };
    return (React.createElement("div", { className: 'comment-not-available-modal' },
        React.createElement("div", { className: 'comment-announcement' },
            React.createElement("p", null, "The comment you were looking for is no longer available."),
            React.createElement(Button, { onClick: invalidCommentReload }, "Ok"))));
};
export default CommentNotAvailableModal;
